import { AllowedAccess } from 'react-permission-role'
import {  useLocation, useParams } from 'react-router-dom'
import { Card, CardContent, Grid } from '@mui/material'

import { useFechInitLeases } from './hooks'

import { ContractsTable } from './ContractsTable'
import { ContractAppliesForm } from './ContractForm'
import { ContractExtraExpenses } from './ContractExtraExpenses'
import { ModalModule } from './ModalModule'

import { LinearLoading } from 'common'

const LeasesContracts = () => {

    const location = useLocation();
    const paramsURL = useParams();
    const useFetchInit = useFechInitLeases({location, paramsURL})

    const {
        globalStates,
        FetchData,
    } = useFetchInit
    
    const { showForm, showFormExpenses} = globalStates

    const { fetchAllLeaseContracts } = FetchData
    const { loadingFetchLeaseContracts } = fetchAllLeaseContracts
  
    return (
        <AllowedAccess permissions={['130_ARRENDAMIENTOS_CONTRATOS']} renderAuthFailed={<p>Error</p>}>
            <div className='content'>
                <ModalModule useFetchInit={useFetchInit} />
                {((!showForm)&&(!showFormExpenses)) && (
                    <div className='panel-body' id='listadoregistros'>
                        <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                <Card style={{zIndex:'1'}}>
                                    <CardContent>
                                    <div className='h4 mt-1 mb-1'> Contratos Arrendamientos</div>
                                    <div className="border-bottom border-dark"></div>
                                    {loadingFetchLeaseContracts && ( <LinearLoading  /> )}
                                    <div className="pt-4"></div>
                                        <ContractsTable 
                                            useFetchInit={useFetchInit}
                                        />
                                    </CardContent>
                                </Card>
                            </Grid>     
                        </Grid>
                    </div>
                )}
                {(showForm) && (
                    <div className='panel-body' id='viewercontratos'>
                        <ContractAppliesForm
                            useFetchInit={useFetchInit}
                        />
                    </div>
                )}
                {(showFormExpenses) && (
                    <div className='panel-body' id='viewerexpenses'>
                        <ContractExtraExpenses
                            useFetchInit={useFetchInit}
                        />
                    </div>
                )}
            </div>
        </AllowedAccess>
    )
    
}

export {
    LeasesContracts
}